import React, { useEffect, useMemo, useState } from "react";

import { useDispatch, useSelector } from "react-redux";
import Loading from "@/elements/Loading/Loading";
import { Inter } from "next/font/google";
import { cn } from "@/lib/utils";
import StockDetailsHeader from "./StockDetailsHeader";
import StockMarketDepth from "./StockMarketDepth";
import StockOHLCDetails from "./StockOHLCDetails";
import StockOtherDetails from "./StockOtherDetails";
import StockDetailsFooter from "./StockDetailsFooter";
import StockDetailsMain from "./StockDetailsMain";
import PositionsDetailsClosed from "./PositionsDetailsClosed";
import { useScale } from "@/hooks/useScale";
import StockDetailsTopButton from "./StockDetailsTopButton";
import { useSubscription } from "react-stomp-hooks";
import { fetchStockLivePriceDetail } from "@/lib/stockdetails";
import { WebSocketSample } from "@/contexts/WebSocket";
import { getForGttOrderStatus } from "@/lib/placeOrder";

const inter = Inter({
    subsets: ["latin"],
    variable: "--font-inter"
});

export default function StockDetailsBF() {
    const [data, setData] = useState({});
    const zoom = useScale(1440);
    const { scripCode, isStocksDetailsBfOpen, status, orderDetails, gttDetails, positionsDetails, holdingDetails } =
        useSelector((state) => state.stocksDetails);

    return (
        <div
            className={cn(
                "w-full md:w-[383px] transition-all fixed bottom-0 top-0 right-[-583px] md:right-[-383px] bg-white shadow-none border-s overflow-x-hidden overflow-y-auto",
                inter.variable,
                { "right-0  md:right-0 shadow-[0_0_30px_30px_rgba(0,0,0,0.1)]": isStocksDetailsBfOpen }
            )}
            style={{ zIndex: 50, zoom }}
        >
            {status === "loading" || status === "idle" ? (
                <Loading />
            ) : (
                <div className="flex flex-col justify-between items-stretch h-full">
                    {scripCode && <StockDetailsSocket scripCode={scripCode} setData={setData} />}
                    <StockDetailsHeader trade={data?.trade} />
                    <StockDetailsTopButton />
                    <StockDetailsMain trade={data?.trade} />
                    <StockOtherDetails trade={data?.trade} />
                    {/* remove for close order  */}
                    {orderDetails?.status !== "Traded" && (
                        <>
                            {(!gttDetails?.status || getForGttOrderStatus(gttDetails?.status)[0] !== "INACTIVE") && (
                                <StockMarketDepth
                                    mbp={data?.mbp}
                                    totalBuyQty={data?.totalBuyQty}
                                    totalSellQty={data?.totalSellQty}
                                />
                            )}
                            <StockOHLCDetails data={data} />
                        </>
                    )}

                    {positionsDetails?.symbol && <PositionsDetailsClosed />}
                    <div className="flex-1" />
                    <StockDetailsFooter />
                </div>
            )}
        </div>
    );
}

export function StockDetailsSocket({ scripCode, setData }) {
    const stockData = useSelector((state) => state.livePrice.subscriptedStocks);
    const trade = useMemo(
        () => stockData?.[scripCode]?.[WebSocketSample.TRADE_EXTND],
        [stockData?.[scripCode]?.[WebSocketSample.TRADE_EXTND]]
    );

    useEffect(() => {
        fetchStockLivePriceDetail(scripCode).then((data) => setData(data));
    }, []);

    useSubscription(`/stock/live-price-websocket/${scripCode}`, (res) => {
        const data = JSON.parse(res.body ?? "{}");
        setData({ ...data, trade: trade ?? data?.trade });
    });
    return;
}
